import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import TerminosYCondicionesApiHelper from "./TerminosYCondicionesApiHelper";
import { Box, Typography, Container } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import bgImage from "assets/img/login.jpeg";


const useStyles = makeStyles(() => ({
  '@global': {
    '.Auth-fullPage-2': {
      padding: '0 !important',
    },
    '.Auth-fullPage-2::after': {
      content: 'none !important',
    },
    '.jss2': {
      padding: '0 !important',
    },
  },
  fullPage: {
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem",
    position: "relative",
  },
  contenido: {
    backgroundColor: "white",
    padding: "2rem",
    borderRadius: "12px",
    color: "black",
    zIndex: 5,
    width: "100%",
    boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
  },
}));




const TerminosYCondiciones = ({ match }) => {
    const id = match.params.id;
    const [data, setData] = useState(null);
    const classes = useStyles();

    useEffect(() => {
        const cargarDatos = async () => {
            try {
                const response = await TerminosYCondicionesApiHelper.obtenerTerminosYCondiciones(id);
                setData(response);
            } catch (error) {
                console.error("Error cargando términos:", error);
            }
        };

        cargarDatos();
    }, [id]);

    if (!data) return null;

    return (
        <div className={classes.fullPage}>
            <Box className={classes.contenido}>
                <Typography variant="h4" align="center" gutterBottom>
                    {data.nombre} ({data.nit})
                </Typography>
                <Typography variant="h6" align="center" color="textSecondary" gutterBottom>
                    {data.lema}
                </Typography>
                <Box mt={4}>
                    <Typography
                        variant="body1"
                        style={{ whiteSpace: "pre-line", fontSize: "1.1rem", lineHeight: 1.6 }}
                    >
                        {data.contenido}
                    </Typography>
                </Box>
            </Box>
        </div>
    );
};

export default withRouter(TerminosYCondiciones);
